import { TicketStatus } from './TicketStatusBadge.types'

// Border color for top border by status
export const borderColorMap: Record<TicketStatus, string> = {
  [TicketStatus.APPROVED]: 'border-t-[var(--ticket-status-approved-border)]',
  [TicketStatus.WAITING]: 'border-t-[var(--ticket-status-waiting-border)]',
  [TicketStatus.SETTLED]: 'border-t-[var(--ticket-status-settled-border)]',
  [TicketStatus.CANCELLED]: 'border-t-[var(--ticket-status-cancelled-border)]',
  [TicketStatus.REJECTED]: 'border-t-[var(--ticket-status-cancelled-border)]',
  [TicketStatus.LOSE]: 'border-t-[var(--ticket-status-cancelled-border)]',
  [TicketStatus.WIN]: 'border-t-[var(--ticket-status-approved-border)]',
  [TicketStatus.BET_FAILED]: 'border-t-[var(--ticket-status-cancelled-border)]',
  [TicketStatus.ROUND_CANCELLED]:
    'border-t-[var(--ticket-status-cancelled-border)]',
  [TicketStatus.USER_CANCELLED]:
    'border-t-[var(--ticket-status-cancelled-border)]',
}
